import { render, staticRenderFns } from "./Cquiz.vue?vue&type=template&id=91ee5f32&scoped=true&"
import script from "./Cquiz.vue?vue&type=script&lang=js&"
export * from "./Cquiz.vue?vue&type=script&lang=js&"
import style0 from "./Cquiz.vue?vue&type=style&index=0&id=91ee5f32&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91ee5f32",
  null
  
)

export default component.exports